var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('tree-crud',{attrs:{"cfg":_vm.conf,"timestamp":_vm.timestamp}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }